import { Button, Dropdown, Menu } from "antd"
import Tooltip from "components-old/Tooltip"
import MenuItemInnerSelectable from "components-old/ui/SearchDrop/MenuItemInnerSelectable"
import { cn } from "lib/utils"
import { memo } from "react"

export interface SegmentDropdownProps<T> {
  selected: string
  setSelected: (value: string) => void
  title?: string
  segments: {
    value: string
    label: string
    icon?: React.ReactNode
    filterFn?: (data: T) => boolean
    filtered?: T[]
    filteredTotal?: number
    labelDefault?: string
  }[]
  data?: T[]
  segmentCounts?: Record<string, number>
  index?: number
  totalCount?: number
}

function SegmentDropdown<T>(props: SegmentDropdownProps<T>) {
  const option = props.segments.find((option) => option.value === props.selected)

  const isFiltering = !!option && option?.value !== props.segments?.[0]?.value

  const content = (
    <Button className={cn("rounded-xl", isFiltering && "aldeia:!bg-selected-lighter aldeia:dark:!bg-selected-active dark:!text-white")}>
      {option?.icon}
      {option?.labelDefault || option?.label || props.segments?.[0]?.labelDefault || props.segments?.[0]?.label || "Tudo"}
      <i className="ml-2 text-xs fas fa-caret-down" />
    </Button>
  )

  return (
    <Dropdown
      overlay={
        <Menu>
          {props.segments.map((option, i) => {
            const totalCount = option.value == "" ? props.totalCount : props.segmentCounts?.[`${option.value}-${props.index}`]
            return (
              <SegmentDropdownItem
                key={option.value}
                option={option}
                selected={props.selected}
                setSelected={props.setSelected}
                filteredTotal={totalCount ?? option.filteredTotal ?? option.filtered?.length ?? 0}
              />
            )
            // const hasCount = !!filteredTotal
            // return (
            //   <Menu.Item
            //     key={option.value}
            //     onClick={(e) => {
            //       props.setSelected(option.value)
            //     }}
            //   >
            //     <MenuItemInnerSelectable selected={props.selected == option.value} title={option.label}>
            //       {/* <div className="flex items-center">
            //       {(option?.filteredTotal ?? option?.filtered?.length) && (
            //         <div className="w-9 mr-0.5">
            //           <span className="px-1 text-xs font-medium truncate rounded-full border border-solid bg-slate-100 aldeia:bg-selected-light dark:bg-transparent dark:font-bold border-slate-200 dark:border-divider-100">
            //             {option?.filteredTotal ?? option.filtered?.length}
            //           </span>
            //         </div>
            //       )} */}
            //       {option.label}
            //       {hasCount && (
            //         <span className="px-1 ml-2 text-xs font-medium truncate rounded-full border border-solid bg-slate-100 aldeia:bg-selected-light dark:bg-transparent dark:font-bold border-slate-200 dark:border-divider-100">
            //           {filteredTotal}
            //         </span>
            //       )}
            //       {/* </div> */}
            //       {/* {option?.filtered?.length ? ` (${option.filtered.length})` : ""} */}
            //     </MenuItemInnerSelectable>
            //   </Menu.Item>
            // )
          })}
        </Menu>
      }
      trigger={["click"]}
    >
      {props.title ? (
        <div>
          <Tooltip title={props.title || "Segmento"} side="bottom">
            {content}
          </Tooltip>
        </div>
      ) : (
        content
      )}
    </Dropdown>
  )
}

const SegmentDropdownItem = memo(
  (props: { option: any; selected: string; setSelected: (value: string) => void; filteredTotal: number }) => {
    const hasCount = !!props.filteredTotal

    return (
      <Menu.Item
        key={props.option.value}
        onClick={(e) => {
          props.setSelected(props.option.value)
        }}
      >
        <MenuItemInnerSelectable selected={props.selected == props.option.value} title={props.option.label}>
          {/* <div className="flex items-center">
        {(option?.filteredTotal ?? option?.filtered?.length) && (
          <div className="w-9 mr-0.5">
            <span className="px-1 text-xs font-medium truncate rounded-full border border-solid bg-slate-100 aldeia:bg-selected-light dark:bg-transparent dark:font-bold border-slate-200 dark:border-divider-100">
              {option?.filteredTotal ?? option.filtered?.length}
            </span>
          </div>
        )} */}
          {props.option.label}
          {hasCount && (
            <span className="px-1 ml-2 text-xs font-medium truncate rounded-full border border-solid bg-slate-100 aldeia:bg-selected-light dark:bg-transparent dark:font-bold border-slate-200 dark:border-divider-100">
              {props.filteredTotal}
            </span>
          )}
          {/* </div> */}
          {/* {option?.filtered?.length ? ` (${option.filtered.length})` : ""} */}
        </MenuItemInnerSelectable>
      </Menu.Item>
    )
  },
)

export default SegmentDropdown
